import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Reset from './Components/Auth/Reset';
import RequestReset from './Components/Auth/RequestReset';
import Logout from './Components/App/Logout';
import Dashboard from './Components/App/Dashboard';
import PrivateRoute from './Components/PrivateRoute';
import Jobs from './Components/App/Jobs';
import JobAdd from './Components/App/Jobs/Add';
import Users from './Components/App/Users';
import UserAdd from './Components/App/Users/Add';
import Types from './Components/App/Types';
import TypeAdd from './Components/App/Types/Add';
import Locations from './Components/App/Locations';
import LocationAdd from './Components/App/Locations/Add';
import SubLocationAdd from './Components/App/Locations/SubLocations/Add';
import Reports from './Components/App/Reports/';
import Report from './Components/App/Reports/Report';
import Companies from './Components/App/Companies';
import CompanyAdd from './Components/App/Companies/Add';
import Handyman from './Components/App/Reports/Handyman/index';

const App = () => (
    <Switch>
        <Route exact path='/' render={() => <Login />} />
        <Route exact path='/reset' render={(url) => <Reset url={url}/>} />
        <Route exact path='/request/reset' render={() => <RequestReset />} />
        <PrivateRoute exact path='/logout' render={() => <Logout />} />
        <PrivateRoute exact path='/dashboard' page={false} render={(url) => <Dashboard url={url}/>} />
        <PrivateRoute exact path='/jobs' page='jobs' render={(url) => <Jobs url={url}/>} />
        <PrivateRoute exact path='/jobs/add' page='jobs' render={() => <JobAdd />} />
        <PrivateRoute exact path='/users' page='users' render={() => <Users />} />
        <PrivateRoute exact path='/users/add' page='users' render={() => <UserAdd />} />
        <PrivateRoute exact path='/types' page='types' render={() => <Types />} />
        <PrivateRoute exact path='/types/add' page='types' render={() => <TypeAdd />} />
        <PrivateRoute exact path='/locations' page='locations' render={() => <Locations />} />
        <PrivateRoute exact path='/locations/add' page='locations' render={() => <LocationAdd />} />
        <PrivateRoute path='/sub-locations/add/:id' page='sub_locations' render={({match}) => <SubLocationAdd location_id={match.params.id}/>} />
        <PrivateRoute exact path='/reports' page='stats' render={() => <Reports />} />
        <PrivateRoute path='/reports/:id' page='stats' render={({match}) => <Report reportId={match.params.id} />} />
        <PrivateRoute exact path='/handyman/:id' page='stats' render={({match: { params : { id }}, location: { hash }}) => <Handyman hash={hash} level={id}/>} />
        <PrivateRoute exact path='/companies' page='companies' render={() => <Companies />} />
        <PrivateRoute exact path='/companies/add' page='companies' render={() => <CompanyAdd />} />
    </Switch>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js